(() => {
  if (window.__riadoStockVisibilityInit) return;
  window.__riadoStockVisibilityInit = true;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
  const soldOutLabel = normalize(window.RIADO_SOLD_OUT_LABEL || 'Ausverkauft');

  const nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    try {
      const rawUrl = typeof input === 'string' ? input : input instanceof Request ? input.url : '';
      const predictivePath = window.routes && window.routes.predictive_search_url;

      if (rawUrl && predictivePath && rawUrl.includes(predictivePath)) {
        const url = new URL(rawUrl, window.location.origin);
        url.searchParams.set('resources[options][unavailable_products]', 'hide');

        if (typeof input === 'string') {
          input = /^https?:/i.test(rawUrl) ? url.toString() : `${url.pathname}${url.search}`;
        } else if (input instanceof Request) {
          input = new Request(url.toString(), input);
        }
      }
    } catch (error) {
      // Fall back to Shopify's original request if URL normalization fails.
    }

    return nativeFetch(input, init);
  };

  function isSearchPage() {
    return window.location.pathname.includes('/search');
  }

  function ensureUnavailableInput(form) {
    if (!form) return;

    let input = form.querySelector('input[name="options[unavailable_products]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'options[unavailable_products]';
      form.appendChild(input);
    }
    input.value = 'hide';
  }

  function ensureSearchOptions(root = document) {
    const forms = [];
    if (root.matches && root.matches('form')) forms.push(root);
    if (root.querySelectorAll) root.querySelectorAll('form').forEach((form) => forms.push(form));

    forms.forEach((form) => {
      const action = form.getAttribute('action') || '';
      const searchForm = action.includes('/search') || (isSearchPage() && /^Facet/.test(form.id || ''));
      if (searchForm) ensureUnavailableInput(form);
    });
  }

  function hideSoldOutCards(root = document) {
    const scopes = [];
    if (root.matches && root.matches('#ProductGridContainer, .template-search__results')) scopes.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('#ProductGridContainer, .template-search__results').forEach((scope) => scopes.push(scope));
    }

    scopes.forEach((scope) => {
      scope.querySelectorAll('li.grid__item').forEach((item) => {
        const soldOut = Array.from(item.querySelectorAll('.badge')).some(
          (badge) => normalize(badge.textContent) === soldOutLabel
        );

        if (soldOut) {
          item.hidden = true;
          item.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  function apply(root = document) {
    ensureSearchOptions(root);
    hideSoldOutCards(root);
  }

  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement) ensureSearchOptions(event.target);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(document), { once: true });
  } else {
    apply(document);
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) apply(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
